import request from "@/api/request";

export function loadLocale() {
    const isAuthenticated = (localStorage.getItem('authtoken') && localStorage.getItem('authtoken') !== '')
    if (!isAuthenticated) {
        const lang = 'DE'
        return request({
            url: `/locale/${lang}`,
            method: 'get',
        });
    }

    return request({
        url: `/locale`,
        method: 'get',
    });
}
